export type Lang = 'en' | 'ar';

export const translations = {
  en: {
    dir: 'ltr' as const,
    appName: 'DocAlert',
    tagline: 'Never miss a document expiry again',
    login: 'Sign In',
    register: 'Create Account',
    email: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    companyName: 'Company Name',
    mobile: 'Mobile Number',
    country: 'Country',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUpNow: 'Sign up now',
    signInNow: 'Sign in now',
    verifyEmail: 'Verify Your Email',
    verifyEmailMsg: 'We sent a verification link to your email. Please check your inbox and click the link to activate your account.',
    resendEmail: 'Resend verification email',
    dashboard: 'Dashboard',
    documents: 'Documents',
    addDocument: 'Add Document',
    notifications: 'Notifications',
    reports: 'Reports',
    users: 'Users',
    branches: 'Branches',
    settings: 'Settings',
    logout: 'Logout',
    totalDocuments: 'Total Documents',
    activeDocuments: 'Active',
    expiringSoon: 'Expiring Soon',
    expired: 'Expired',
    todayReminders: "Today's Reminders",
    recentDocuments: 'Recently Added',
    documentName: 'Document Name',
    documentType: 'Document Type',
    branch: 'Branch',
    authority: 'Authority / Organization',
    docNumber: 'Document Number',
    issueDate: 'Issue Date',
    expiryDate: 'Expiry Date',
    remainingDays: 'Remaining Days',
    reminderDays: 'Reminder Days',
    status: 'Status',
    attachment: 'Attachment',
    actions: 'Actions',
    search: 'Search documents...',
    filterStatus: 'All Statuses',
    filterType: 'All Types',
    addNew: 'Add Document',
    importExcel: 'Import Excel',
    exportExcel: 'Export Excel',
    exportPDF: 'Export PDF',
    save: 'Save Document',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    download: 'Download',
    notes: 'Notes',
    uploadAttachment: 'Upload Attachment',
    dragDrop: 'Drag & drop files here, or click to browse',
    supportedFormats: 'Supported: PDF, JPG, PNG, DOCX, XLSX',
    reminderPresets: 'Reminder Presets',
    daysBeforeExpiry: 'days before expiry',
    allNotifications: 'All',
    unread: 'Unread',
    read: 'Read',
    archived: 'Archived',
    markAllRead: 'Mark all as read',
    archiveAll: 'Archive all',
    openDocument: 'Open Document',
    noNotifications: 'No notifications yet',
    noNotificationsMsg: 'You will receive alerts here when documents are approaching expiry.',
    days: 'days',
    daysLeft: 'days left',
    daysOverdue: 'days overdue',
    active: 'Active',
    company: 'Company',
    selectType: 'Select document type',
    selectBranch: 'Select branch',
    selectCountry: 'Select country',
    required: 'This field is required',
    invalidEmail: 'Enter a valid email address',
    passwordMismatch: 'Passwords do not match',
    passwordLength: 'Password must be at least 8 characters',
    loading: 'Loading...',
    saving: 'Saving...',
    saved: 'Saved',
    deleteConfirm: 'Are you sure you want to delete this document?',
    deleteSuccess: 'Document deleted successfully',
    saveSuccess: 'Document saved successfully',
    importSuccess: 'Documents imported successfully',
    monthlyExpiry: 'Monthly Expiry Timeline',
    statusDistribution: 'Status Distribution',
    byType: 'By Document Type',
    lastUpdated: 'Last updated',
    justNow: 'just now',
    superAdmin: 'Super Admin',
    profile: 'My Profile',
    switchLang: 'العربية',
    filterBranch: 'All Branches',
    tableIcon: 'TableCellsIcon',
  },
  ar: {
    dir: 'rtl' as const,
    appName: 'تنبيه الوثائق',
    tagline: 'لا تفوتك صلاحية أي وثيقة مجدداً',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    fullName: 'الاسم الكامل',
    companyName: 'اسم الشركة',
    mobile: 'رقم الجوال',
    country: 'الدولة',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    signUpNow: 'سجّل الآن',
    signInNow: 'ادخل الآن',
    verifyEmail: 'تحقق من بريدك الإلكتروني',
    verifyEmailMsg: 'أرسلنا رابط التحقق إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد والنقر على الرابط لتفعيل حسابك.',
    resendEmail: 'إعادة إرسال رسالة التحقق',
    dashboard: 'لوحة التحكم',
    documents: 'الوثائق',
    addDocument: 'إضافة وثيقة',
    notifications: 'الإشعارات',
    reports: 'التقارير',
    users: 'المستخدمون',
    branches: 'الفروع',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    totalDocuments: 'إجمالي الوثائق',
    activeDocuments: 'نشطة',
    expiringSoon: 'تنتهي قريباً',
    expired: 'منتهية',
    todayReminders: 'تذكيرات اليوم',
    recentDocuments: 'أحدث الوثائق',
    documentName: 'اسم الوثيقة',
    documentType: 'نوع الوثيقة',
    branch: 'الفرع',
    authority: 'الجهة / الجهة المصدرة',
    docNumber: 'رقم الوثيقة',
    issueDate: 'تاريخ الإصدار',
    expiryDate: 'تاريخ الانتهاء',
    remainingDays: 'الأيام المتبقية',
    reminderDays: 'أيام التذكير',
    status: 'الحالة',
    attachment: 'المرفق',
    actions: 'الإجراءات',
    search: 'البحث في الوثائق...',
    filterStatus: 'جميع الحالات',
    filterType: 'جميع الأنواع',
    filterBranch: 'جميع الفروع',
    addNew: 'إضافة وثيقة',
    importExcel: 'استيراد Excel',
    exportExcel: 'تصدير Excel',
    exportPDF: 'تصدير PDF',
    save: 'حفظ الوثيقة',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    view: 'عرض',
    download: 'تنزيل',
    notes: 'ملاحظات',
    uploadAttachment: 'رفع مرفق',
    dragDrop: 'اسحب وأفلت الملفات هنا، أو انقر للتصفح',
    supportedFormats: 'المدعوم: PDF، JPG، PNG، DOCX، XLSX',
    reminderPresets: 'إعدادات التذكير',
    daysBeforeExpiry: 'يوم قبل الانتهاء',
    allNotifications: 'الكل',
    unread: 'غير مقروء',
    read: 'مقروء',
    archived: 'مؤرشف',
    markAllRead: 'وضع الكل كمقروء',
    archiveAll: 'أرشفة الكل',
    openDocument: 'فتح الوثيقة',
    noNotifications: 'لا توجد إشعارات بعد',
    noNotificationsMsg: 'ستتلقى تنبيهات هنا عندما تقترب الوثائق من انتهاء صلاحيتها.',
    days: 'يوم',
    daysLeft: 'يوم متبقي',
    daysOverdue: 'يوم متأخر',
    active: 'نشط',
    company: 'الشركة',
    selectType: 'اختر نوع الوثيقة',
    selectBranch: 'اختر الفرع',
    selectCountry: 'اختر الدولة',
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'أدخل عنوان بريد إلكتروني صحيح',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    loading: 'جاري التحميل...',
    saving: 'جاري الحفظ...',
    saved: 'تم الحفظ',
    deleteConfirm: 'هل أنت متأكد من حذف هذه الوثيقة؟',
    deleteSuccess: 'تم حذف الوثيقة بنجاح',
    saveSuccess: 'تم حفظ الوثيقة بنجاح',
    importSuccess: 'تم استيراد الوثائق بنجاح',
    monthlyExpiry: 'جدول الانتهاء الشهري',
    statusDistribution: 'توزيع الحالات',
    byType: 'حسب نوع الوثيقة',
    lastUpdated: 'آخر تحديث',
    justNow: 'الآن',
    superAdmin: 'مدير النظام',
    profile: 'ملفي الشخصي',
    switchLang: 'English',
  },
} as const;

export type Translations = typeof translations['en'];